export default __webpack_public_path__ + "static/media/chevron-vertical-12.2cd2331b.svg";